import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Quiz from './Quiz';
import Mission from './Mission';
import Guide from './Guide';
import Free from './Free';
import Workspace from './Workspace';
import MazeStatic from './MazeStatic';
import CurriculumIntro from './Curriculum/Intro';
import CurriculumGoal from './Curriculum/Goal';
import CurriculumPrepare from './Curriculum/Prepare';
import CurriculumQuiz from './Curriculum/Quiz';
import CurriculumStudy from './Curriculum/Study';
import CurriculumSummary from './Curriculum/Summary';

class AppComponent extends Component {
    componentDidMount() {
        window.data = this.props.common;
    }
    render() {
        const { mode, data, theme } = this.props.common;
        if (!Entry.mediaFilePath) {
            Entry.mediaFilePath = '/lib/entryjs/images/';
        }
        let View;
        switch (mode) {
            case 'quiz':
                const { answerData, quizData } = data;
                View = (
                    <Quiz
                        data={data}
                        saveAnswerData={answerData}
                        quizData={quizData}
                        injectOption={data.injectOption || {}}
                    />
                );
                break;
            case 'workspace':
                View = <Workspace data={data} />;
                break;
            case 'free':
                View = <Free data={data} />;
                break;
            case 'mission':
                View = <Mission data={data} />;
                break;
            case 'guide':
                View = <Guide data={data} theme={theme} />;
                break;
            case 'maze':
            case 'maze_static':
                View = <MazeStatic data={data} />;
                break;
            case 'curriculum_intro':
                View = <CurriculumIntro data={data} />;
                break;
            case 'curriculum_goal':
                View = <CurriculumGoal data={data} />;
                break;
            case 'curriculum_prepare':
                View = <CurriculumPrepare data={data} />;
                break;
            case 'curriculum_study':
                View = <CurriculumStudy data={data} />;
                break;
            case 'curriculum_summary':
                View = <CurriculumSummary data={data} />;
                break;
            case 'curriculum_quiz':
                View = <CurriculumQuiz data={data} />;
                break;
            default:
                View = <div>default</div>;
                break;
        }

        return <div className={mode}>{View}</div>;
    }
}

AppComponent.defaultProps = {};

AppComponent.propTypes = {
    mode: PropTypes.string.isRequired,
    data: PropTypes.object,
};

const mapStateToProps = (state) => ({
    ...state,
});

function mapDispatchToProps(dispatch) {
    const actions = {};
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppComponent);



// WEBPACK FOOTER //
// ./components/App.js